import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_API_URL } from "../../Common/common";

export const getAllAuditors = createAsyncThunk("getAllAuditors", async () => {
  try {
    const token = localStorage.getItem("cu_user");
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/user/auditors`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (error) {
    console.error(error);
  }
});

export const getAllApplications = createAsyncThunk(
  "getAllApplications",

  async (applicationStatus) => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${
          process.env.REACT_APP_API_HOST
        }/api/company?auditStatus=${applicationStatus}&stage=${
          applicationStatus === "COMPLETED" ? "CERTIFIER" : "PLANNER"
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getRcExtensionApplications = createAsyncThunk(
  "getRcExtensionApplications",

  async (applicationStatus) => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${
          process.env.REACT_APP_API_HOST
        }/api/cui-application-form/scope-extension?status=${applicationStatus}&stage=${
          applicationStatus === "COMPLETED" ? "CERTIFIER" : "PLANNER"
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getRcRenewalApplications = createAsyncThunk(
  "getRcRenewalApplications",

  async (applicationStatus) => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${
          process.env.REACT_APP_API_HOST
        }/api/cui-application-form?status=${applicationStatus}&stage=${
          applicationStatus === "COMPLETED" ? "CERTIFIER" : "PLANNER"
        }&renewal=true`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getApplicationById = createAsyncThunk(
  "getApplicationById",
  async (applicationId) => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/company/${encodeURIComponent(
          applicationId
        )}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getRenewApplicationById = createAsyncThunk(
  "getRenewApplicationById",
  async (applicationId) => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${
          process.env.REACT_APP_API_HOST
        }/api/cui-application-form/${encodeURIComponent(applicationId)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getIncomingExApplicationById = createAsyncThunk(
  "getIncomingExApplicationById",
  async (applicationId) => {
    const bearerToken = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/cui-application-form/scope-extension/${applicationId}`,
        {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

//"assign to me button action"
export const postAssignToMe = createAsyncThunk(
  "postAssignToMe",
  async ({ id, applicationRenewStatus }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          const token = localStorage.getItem("cu_user");
          let url;
          if (applicationRenewStatus === "old") {
            url = `${process.env.REACT_APP_API_HOST}/api/company/self-assign/${id}`;
          } else if (applicationRenewStatus === "renew") {
            url = `${
              process.env.REACT_APP_API_HOST
            }/api/cui-application-form/self-assign/${encodeURIComponent(id)}`;
          } else {
            url = `${
              process.env.REACT_APP_API_HOST
            }/api/cui-application-form/scope-extension/assign/${encodeURIComponent(
              id
            )}`;
          }
          let response;
          if (
            applicationRenewStatus === "old" ||
            applicationRenewStatus === "renew"
          ) {
            response = await axios.patch(
              url,
              {},
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
          } else {
            response = await axios.post(
              url,
              {},
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
          }

          if (response.data.status === "success") {
            resolve(response);
            return response?.data;
          } else {
            reject(response?.data?.message);
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Assigning...",
        success: "Assigned to you successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

export const approveApplication = createAsyncThunk(
  "approveApplication",
  async (applicationId) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const token = localStorage.getItem("cu_user");
        try {
          let res = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/company/self-assign/${applicationId}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Approving...",
        success: "Application approved successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

export const saveAllAudits = createAsyncThunk(
  "saveAllAudits",
  async ({ companyId, applicationRenewStatus, type }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const token = localStorage.getItem("cu_user");
        try {
          let url;
          if (applicationRenewStatus === "old") {
            url = `${process.env.REACT_APP_API_HOST}/api/audit/plan/save/${companyId}`;
          } else {
            url = `${process.env.REACT_APP_API_HOST}/api/cui-application-form/flow/v2/plan/save/${type}/${companyId}`;
          }
          let res;
          if (applicationRenewStatus === "old") {
            res = await axios.patch(
              url,
              {},
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
          } else {
            res = await axios.post(
              url,
              {},
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
          }

          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Saving...",
        success: "All Audits Saved Successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

export const getCount = createAsyncThunk("getCount", async () => {
  try {
    const token = localStorage.getItem("cu_user");
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/company/agg-status/count`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (error) {
    console.error(error);
  }
});

export const PlannerSlice = createSlice({
  name: "planner",
  initialState: {
    allApplications: [],
    appplication: null,
    counts: [],
    entity: [],
    status: "idle",
    error: null,
    rcExtensionApplications: [],
    rcRenewalApplications: [],
    renewApplication: null,
    exApplication: null,
  },
  reducers: {},
  extraReducers: {
    [getAllApplications.pending]: (state) => {
      state.status = "pending";
    },
    [getAllApplications.fulfilled]: (state, action) => {
      state.status = "success";
      state.allApplications = action.payload;
    },
    [getAllApplications.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
    },
    [getApplicationById.pending]: (state) => {
      state.status = "pending";
    },
    [getApplicationById.fulfilled]: (state, action) => {
      state.status = "success";
      state.application = action.payload;
    },
    [getApplicationById.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
    },
    [getRenewApplicationById.pending]: (state) => {
      state.status = "pending";
    },
    [getRenewApplicationById.fulfilled]: (state, action) => {
      state.status = "success";
      state.renewApplication = action.payload;
    },
    [getRenewApplicationById.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
    },
    [getIncomingExApplicationById.pending]: (state) => {
      state.status = "pending";
    },
    [getIncomingExApplicationById.fulfilled]: (state, action) => {
      state.status = "success";
      state.exApplication = action.payload;
    },
    [getIncomingExApplicationById.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
    },
    [getAllAuditors.pending]: (state) => {
      state.status = "pending";
    },
    [getAllAuditors.fulfilled]: (state, action) => {
      state.status = "success";
      state.entity = action.payload;
    },
    [getAllAuditors.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
    },
    [getCount.pending]: (state, action) => {
      state.status = "pending";
    },
    [getCount.fulfilled]: (state, action) => {
      state.counts = action.payload;
      state.status = "success";
    },
    [getCount.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
    },
    [getRcExtensionApplications.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getRcExtensionApplications.fulfilled]: (state, action) => {
      state.status = "success";
      state.rcExtensionApplications = action.payload;
      state.isloading = false;
    },
    [getRcExtensionApplications.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = false;
    },

    // RC Renewal
    [getRcRenewalApplications.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getRcRenewalApplications.fulfilled]: (state, action) => {
      state.status = "success";
      state.rcRenewalApplications = action.payload;
      state.isloading = false;
    },
    [getRcRenewalApplications.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = false;
    },
  },
});

export default PlannerSlice.reducer;
